export function getResultPdfSettings({ productInformation, pdfSettings, isProductBasedFinder = false }) {
  return {
    showPrices: productInformation?.priceType !== 'No price',
    // The product-based result screen always shows product names and ignores the CMS "Name" checkbox,
    // so the printout follows the screen instead of hiding the names.
    showProductNames: isProductBasedFinder || productInformation?.name,
    showProductPageLink: productInformation?.externalProductPageLink,
    showProductPictures: productInformation?.picture,
    showTotalPriceBlock: productInformation?.showTotalPrice,
    showDate: pdfSettings?.showDate,
    showLink: pdfSettings?.showLink,
  };
}
